var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailRoundedBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 18.875L24 24.45L15.5 18.875V17.5L24 22.95L32.5 17.5V18.875Z",
    fill: "#00A3E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48ZM14.45 31.55C14.75 31.85 15.1 32 15.5 32H32.5C32.9 32 33.25 31.85 33.55 31.55C33.85 31.25 34 30.9 34 30.5V17.5C34 17.1 33.85 16.75 33.55 16.45C33.25 16.15 32.9 16 32.5 16H15.5C15.1 16 14.75 16.15 14.45 16.45C14.15 16.75 14 17.1 14 17.5V30.5C14 30.9 14.15 31.25 14.45 31.55Z",
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailRoundedBlue);
export default __webpack_public_path__ + "static/media/email-rounded-blue.c1a783ed7cedbbd8d120951dedd2c518.svg";
export { ForwardRef as ReactComponent };